import { OnInit, Component, Inject, Injector, Input, PLATFORM_ID, ViewEncapsulation, SimpleChanges, OnChanges } from '@angular/core';
import { AbstractComponent } from '../abstract.component';
import { Module } from 'projects/common/model/ModuleModel';
import { isPlatformBrowser } from '@angular/common';
import { v4 as uuidv4 } from 'uuid';
import { LandingModelService } from 'projects/common/services/landingModel.service';
import { FavoriteCardTypeEnum, FavoriteProductEnum, UserFavoriteData, UserFavoriteSortBy, UserFavoriteTracker } from './user-favorite-data.model';
import { Currency } from 'projects/common/model/landingModel';
import { MediaPictureService } from 'projects/common/services/media-picture.service';
import { FavoriteSocialService } from './favorite-social.service';
import { Device } from 'projects/common/model/Device';
import { GridOptions } from '../grid/grid.component';
import { SliderOptions } from '../slider/slider/slider.component';
import { FavoriteClusterComponent } from './favorite-cluster/favorite-cluster.component';
import { UpaTarget } from 'projects/common/services/upa.service';


declare var window: any;

@Component({
  selector: 'user-favorites',
  template: `

      <div class="user-favorites-wrapper {{cardsType}}" [ngClass]="{'-hidden': shouldHideFavoritesWrapper()}">

        <div *ngIf="isFlightsLanding" class="user-favorite-header -eva-3-mb-xlg">
            <text *ngIf="(module.pretitle || module.title || module.subtitle)" [data]="module" [uniqueId]="module.unique_id" [moduleId]="module.id" [moduleIndex]="module.row_number"></text>
        </div>
      
        <div *ngIf="shouldShowDesktopHeader()"
            class="user-favorite-header -eva-3-mb-xlg">

            <img *ngIf="module.logo && mediaPictureService.getMediaUrl(module.logo.src, '56x56') as src" class="logo" [src]="src" loading="lazy" alt="logo"/>
            <text *ngIf="(module.pretitle || module.title || module.subtitle)" [data]="module" [uniqueId]="module.unique_id" [moduleId]="module.id" [moduleIndex]="module.row_number"></text>
            
            <button *ngIf="shouldShowCTAButton()" class="eva-3-btn-ghost -lg favorite-cluster-btn" name="" (click)="handleClickCTAMyFavs()">
                <em class="btn-text favorite-cluster-btn-text">
                    {{"userFavorites.CTABtn.mobile" | translate}}
                </em>
            </button>
        </div>

        <div class="user-favorites-container">
          <div *ngIf="shouldShowMobileHeader()" 
            class="user-favorite-header -eva-3-mb-xlg" [ngClass]="{'with-icon-product': module.data.product_icon}">
            
            <img *ngIf="module.logo && mediaPictureService.getMediaUrl(module.logo.src, '48x48') as src" class="logo" [src]="src" loading="lazy" alt="logo"/>
            <i *ngIf="module.data.product_icon" class="-eva-3-icon-md {{getIconProduct(module.data.product_icon)}}"></i>

            <text *ngIf="shouldShowMobileHeaderText()" [data]="module" [uniqueId]="module.unique_id" [moduleId]="module.id" [moduleIndex]="module.row_number"></text>
          </div>

          <favorites id="favorites-{{module.data && module.data.product ? module.data.product : ''}}"
                  *ngIf="shouldShowFavoritesComponent()"
                  [flow]="flow" [locale]="locale"  [searchId]="searchId"
                  [pageviewId]="pageViewId" [isWhitelabel]="isWhiteLabel"
                  [product]="module.data.product"
                  [socialId]="module.data.social_id"
                  [showHeader]="module.data.show_header"
                  [showClose]="false">
          </favorites>

          <favorite-cluster
            *ngIf="shouldShowFavoriteCluster()"
            [moduleId]="module.id"
            [moduleIndex]="module.row_number"
            [uniqueId]="module.unique_id || 'empty'"
            [locale]="locale"
            [pageViewId]="pageViewId"
            [searchId]="searchId"
            [isWhiteLabel]="isWhiteLabel"
            [flow]="flow" [currency]="currency"
            [showDeleteBtn]="module.data.show_delete_btn ?? false"
            [showAlertBtn]="module.data.show_alert_btn ?? false"
            [screenType]="screenType"
            [favorites]="this.module.data.favorites"
            [maxItems]="module.data.max_items"
            [cardsType]="cardsType"
            [gridOptions]="gridOptions"
            [sliderOptions]="sliderOptions"
            [nextFlow]="nextFlow"
            (favoriteDeleted)="handleFavoriteDeleted($event)"
          ></favorite-cluster>

          <div *ngIf="shouldShowEmptyState()" class="empty-state-container">
            <span class="empty-state-illustration {{this.isDesktop ? 'navigation-searching-illustration' : 'trip-guide-illustration'}}"></span>
            <div class="empty-state-content-container">
              <h3 class="-eva-3-mb-md eva-3-{{this.isDesktop ? 'h3' : 'h4'}}">{{'userFavorites.emptyState.title' | translate}}</h3>
              <p class="-eva-3-mb-md eva-3-{{this.isDesktop ? 'body-1' : 'body-2'}}">{{'userFavorites.emptyState.text' | translate}}</p>
              <eva-button [options]="{type: '-primary', size: this.isDesktop ? '-lg' : '-md' ,link: 'userFavorites.emptyState.CTALink' | translate, link_text: 'userFavorites.emptyState.CTA' | translate}"
              [moduleId]="getModuleId()"
              [upaData]="{label: 'EMPTY_FAVORITE_TRIPPLANNER_BTN'}">
            </eva-button>
            </div>
          </div>

          <ng-container *ngIf="!isGroupedFavoritesEmpty">
            <ng-container *ngIf="currentSortBy === 'DESTINATION_NAME'">
              <div  *ngFor="let destination of getKeys(groupedFavorites)">
                <div class="-eva-3-mb-xxlg -eva-3-valign title-wrapper -eva-3-mt-xxlg">
                  <p class="eva-3-h3 -eva-3-tc-brand-primary-4 -eva-3-ml-lg">{{ destination }}</p>
                </div>

                <favorite-cluster
                  [moduleId]="module.id"
                  [moduleIndex]="module.row_number"
                  [uniqueId]="module.unique_id || 'empty'"
                  [locale]="locale"
                  [pageViewId]="pageViewId"
                  [searchId]="searchId"
                  [isWhiteLabel]="isWhiteLabel"
                  [flow]="flow"
                  [currency]="currency"
                  [showDeleteBtn]="module.data.show_delete_btn ?? false"
                  [showAlertBtn]="module.data.show_alert_btn ?? false"
                  [screenType]="screenType"
                  [favorites]="groupedFavorites[destination]"
                  [cardsType]="cardsType"
                  [gridOptions]="gridOptions"
                  [sliderOptions]="sliderOptions"
                  [nextFlow]="nextFlow"
                  (favoriteDeleted)="handleFavoriteDeleted($event)"
                ></favorite-cluster>

              </div>
            </ng-container>

            <ng-container *ngIf="currentSortBy === 'PRODUCT_DESTINATION_NAME'">
              <div *ngFor="let product of getKeys(groupedFavorites)">

                <p class="eva-3-h4 -eva-3-mb-xxlg -eva-3-mt-xxlg">{{ getProductTranslationKey(product) | translate }}</p>
                <div *ngFor="let destination of getKeys(groupedFavorites[product].destinations); let i = index">

                  <div class="-eva-3-mb-xxlg -eva-3-valign" [ngClass]="{'-eva-3-mt-xxlg': i > 0}">
                    <i class="-eva-3-icon-lg -eva-3-tc-brand-primary-4 {{getIconProduct(product)}}"></i>
                    <p class="eva-3-h3 -eva-3-tc-brand-primary-4 -eva-3-ml-lg">{{ destination }}</p>
                  </div>

                  <favorite-cluster
                    [moduleId]="module.id"
                    [moduleIndex]="module.row_number"
                    [uniqueId]="module.unique_id || 'empty'"
                    [locale]="locale"
                    [pageViewId]="pageViewId"
                    [searchId]="searchId"
                    [isWhiteLabel]="isWhiteLabel"
                    [flow]="flow"
                    [currency]="currency"
                    [showDeleteBtn]="module.data.show_delete_btn || false"
                    [showAlertBtn]="module.data.show_alert_btn || false"
                    [screenType]="screenType"
                    [favorites]="groupedFavorites[product].destinations[destination]"
                    [cardsType]="cardsType"
                    [gridOptions]="gridOptions"
                    [sliderOptions]="sliderOptions"
                    [nextFlow]="nextFlow"
                    (favoriteDeleted)="handleFavoriteDeleted($event)"
                  ></favorite-cluster>
                </div>
              </div>
            </ng-container>


          </ng-container>

        </div>
      </div>
  `,
  styleUrls: ['./user-favorites.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UserFavoritesComponent extends AbstractComponent implements OnInit, OnChanges {
  @Input() override module: Module<UserFavoriteData>;
  @Input() override flow: string = 'landing';
  @Input() currency: Currency;
  @Input() device: Device;
  @Input() gridOptions: GridOptions;
  @Input() sliderOptions: SliderOptions;
  @Input() nextFlow: string = "";

  locale: string;
  pageViewId: string;
  searchId: string;
  isWhiteLabel: boolean;
  isWebview: boolean;
  cardsType: FavoriteCardTypeEnum;

  currentSortBy: UserFavoriteSortBy | null;
  groupedFavorites: any = {};
  isGroupedFavoritesEmpty: boolean = true;
  hasResults: boolean = false;
  FavoriteCardTypeEnum = FavoriteCardTypeEnum;
  isDesktop: boolean = false;
  isFlightsLanding: boolean = false;

  constructor(injector: Injector, @Inject(PLATFORM_ID) private platformId: string,
    landingModelService: LandingModelService,
    public mediaPictureService: MediaPictureService,
    private favoriteSocialService: FavoriteSocialService) {
    super(injector);
    this.isWhiteLabel = landingModelService.getLandingModel().whiteLabel;
    this.isWebview = landingModelService.getLandingModel().webview;
  }

  ngOnInit() {
    this.isDesktop = this.device?.type === "DESKTOP";
    if (isPlatformBrowser(this.platformId)) {
      this.pageViewId = (window as any)?.upaData?.pageview_id ?? "";
      this.searchId = uuidv4();
      this.locale = window?.locale ?? "";
    }

    this.currentSortBy = this.module?.data?.sorted_by ?? null;
    this.sortFavorites();

    this.isGroupedFavoritesEmpty = Object.keys(this.groupedFavorites).length === 0;
    this.cardsType = this.module?.data?.cards_type ?? FavoriteCardTypeEnum.COMMON;
    this.hasResults = (this.module?.data?.favorites?.length ?? 0) > 0;
    this.isFlightsLanding = this.nextFlow === 'CHECKOUT';
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.hasResults) {
      this.hasResults = (changes?.module?.currentValue?.data?.favorites?.length ?? 0) > 0;
    }
  }

  getModuleId(): string {
    return "UserFavoritesModule";
  }

  sortFavorites(): void {
    if (!this.module?.data?.favorites || !Array.isArray(this.module.data.favorites)) {
      return;
    }

    if (this.currentSortBy === UserFavoriteSortBy.DESTINATION_NAME) {
      this.groupFavoritesByDestination();
    } else if (this.currentSortBy === UserFavoriteSortBy.PRODUCT_DESTINATION_NAME) {
      this.groupFavoritesByProductAndDestination();
    }
    else if (this.currentSortBy === UserFavoriteSortBy.DESTINATION) {
      this.module.data.favorites.sort((a, b) => {
        const destinationA = a?.destination ?? '';
        const destinationB = b?.destination ?? '';
        return destinationA.localeCompare(destinationB);
      });
    } else if (this.currentSortBy === UserFavoriteSortBy.PRODUCT) {
      this.module.data.favorites.sort((a, b) => {
        const productA = a?.product ?? '';
        const productB = b?.product ?? '';
        return productA.localeCompare(productB);
      });
    }
  }

  groupFavoritesByDestination(): void {
    if (!this.module?.data?.favorites || !Array.isArray(this.module.data.favorites)) {
      this.groupedFavorites = {};
      return;
    }

    this.groupedFavorites = this.module.data.favorites.reduce((acc, favorite) => {
      if (!favorite || !favorite.destination) {
        return acc;
      }
      const { destination } = favorite;
      if (!acc[destination]) {
        acc[destination] = [];
      }
      acc[destination].push(favorite);
      return acc;
    }, {});
  }

  groupFavoritesByProductAndDestination(): void {
    if (!this.module?.data?.favorites || !Array.isArray(this.module.data.favorites)) {
      this.groupedFavorites = {};
      return;
    }

    this.groupedFavorites = this.module.data.favorites.reduce((acc, favorite) => {
      if (!favorite || !favorite.product || !favorite.destination) {
        return acc;
      }
      const { product, destination } = favorite;
      if (!acc[product]) {
        acc[product] = { _groupedByProduct: true, destinations: {} };
      }
      if (!acc[product].destinations[destination]) {
        acc[product].destinations[destination] = [];
      }
      acc[product].destinations[destination].push(favorite);
      return acc;
    }, {});
  }

  getKeys(obj: object): string[] {
    return obj ? Object.keys(obj) : [];
  }

  private iconProductMap = {
    'FLIGHT': 'eva-3-icon-flights',
    'ACCOMMODATION': 'eva-3-icon-hotels-ui',
    'ACTIVITY': 'eva-3-icon-tickets-ui',
    'CAR': 'eva-3-icon-cars-ui',
    'TRANSFER': 'eva-3-icon-traslate-ui'
  };

  getIconProduct(product: string): string {
    return product ? (this.iconProductMap[product] ?? '') : '';
  }

  getProductTranslationKey(product: string): string {
    return product ? `userFavorites.productTitle.${product}` : '';
  }

  handleFavoriteDeleted(favoriteId: string): void {
    if (!favoriteId || !this.module?.data?.favorites) {
      return;
    }
    this.module.data.favorites = this.module.data.favorites.filter(favorite => favorite?.id !== favoriteId);
    this.sortFavorites();
    this.isGroupedFavoritesEmpty = Object.keys(this.groupedFavorites).length === 0;
  }

  handleClickCTAMyFavs(): void {
    if (typeof window !== 'undefined' && FavoriteClusterComponent.FAVORITE_CTA_URL) {
      window.open(FavoriteClusterComponent.FAVORITE_CTA_URL, '_blank');
      this.favoriteSocialService.sendTracker(this.module.id, this.module.unique_id || 'empty', this.module.row_number, 'FAVORITE_CTA', UserFavoriteTracker.OPEN, UpaTarget.FAVORITES);
    }
  }

  isEmptyState(): boolean {
    return this.module?.data?.favorites ? this.module.data.favorites.some(favorite => favorite?.product === FavoriteProductEnum.EMPTY_CARD) : false;
  }

  shouldHideFavoritesWrapper(): boolean {
    return this.nextFlow === 'CHECKOUT' && !this.hasResults;
  }

  shouldShowDesktopHeader(): boolean {
    return !this.isFlightsLanding && this.isDesktop;
  }

  shouldShowCTAButton(): boolean {
    const favorites = this.module?.data?.favorites;
    const maxItems = this.module?.data?.max_items;
    return favorites && favorites.length === maxItems;
  }

  shouldShowMobileHeader(): boolean {
    return !this.isFlightsLanding && 
           !this.isDesktop && 
           !!(this.module?.data?.favorites && 
           this.module.data.favorites.length > 0 && 
           (this.module?.pretitle || this.module?.title || this.module?.subtitle));
  }

  shouldShowMobileHeaderText(): boolean {
    return !!(this.module?.data?.favorites && 
           this.module.data.favorites.length > 0 && 
           this.hasResults && 
           (this.module?.pretitle || this.module?.title || this.module?.subtitle));
  }

  shouldShowFavoritesComponent(): boolean {
    return !!(this.module?.data?.product && 
           this.pageViewId && 
           this.searchId && 
           this.module?.data?.social_id);
  }

  shouldShowFavoriteCluster(): boolean {
    return !!(this.module?.data?.favorites && 
           this.isGroupedFavoritesEmpty && 
           !this.isEmptyState());
  }

  shouldShowEmptyState(): boolean {
    return !!(this.module?.data?.favorites && 
           this.isGroupedFavoritesEmpty && 
           this.isEmptyState());
  }

}
